import React, { useRef } from 'react';
import SectionHead from './SectionHead';
import { PROJECTS } from '../data';
import { useLang } from '../LangContext';
import { useScramble } from '../hooks/useScramble';

function SpotlightCard({ p, lang, prefix }) {
  const ref = useRef(null);
  const [name, playName] = useScramble(p.name);

  const handleMove = (e) => {
    if (!ref.current) return;
    const rect = ref.current.getBoundingClientRect();
    ref.current.style.setProperty('--sx', `${((e.clientX - rect.left) / rect.width) * 100}%`);
    ref.current.style.setProperty('--sy', `${((e.clientY - rect.top) / rect.height) * 100}%`);
  };

  const handleLeave = () => {
    if (!ref.current) return;
    ref.current.style.removeProperty('--sx');
    ref.current.style.removeProperty('--sy');
  };

  return (
    <div ref={ref} className="pgrid__card tgt" onMouseEnter={playName} onMouseMove={handleMove} onMouseLeave={handleLeave}>
      <div className="pgrid__top">
        <span className="pgrid__num">{prefix}{p.id}</span>
        {p.live && <span className="pgrid__live">● LIVE</span>}
      </div>
      <div className="pgrid__name">{name}</div>
      <p className="pgrid__desc">{p.desc[lang]}</p>
      <div className="pgrid__foot">
        <span className="pgrid__role">{p.role}</span>
        {p.href && <a href={p.href} target="_blank" rel="noopener noreferrer" className="pgrid__link">↗</a>}
      </div>
    </div>
  );
}

export default function Projects() {
  const { lang, t } = useLang();

  return (
    <section className="s fullpage-section" id="projects">
      <div className="s__inner">
        <SectionHead label={t.projects.label} title={t.projects.title} />
        <div className="pgrid">
          {PROJECTS.map((p) => (
            <SpotlightCard key={p.id} p={p} lang={lang} prefix={t.projects.prefix} />
          ))}
        </div>
      </div>
    </section>
  );
}
